/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BiometricsResultStatus {
  VALID = 'VALID',
  INVALID = 'INVALID',
}
